import React, { memo, useEffect, useMemo, useRef } from "react";
import config from "../../../utils/config/config";
import PlusIcon from "../../../assets/svg/plusIcon";
import GreenCheck from "../../../assets/svg/greenCheck";


const DomainIcon = memo(({ logoUrl, name }) => {
    const src = logoUrl ? `${config.contentURL}${logoUrl}` : "FrontMlogo";
    return (
        <img
            src={src}
            className="w-[20px] h-[20px] object-contain"
            alt={`${name} logo`}
            loading="lazy"
        />
    );
});


export const DomainSwitcher = ({
    selectedDomain,
    domainList,
    onDomainChange,
    onClose,
    setShowNewProvider
}) => {
    const modalRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose?.(); // Call the onClose function if click is outside
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);


    const sortedDomains = useMemo(
        () => [...domainList].sort((a, b) => a.name.localeCompare(b.name)),
        [domainList]
    );

    return (
        <div className="fixed bg-[#15194bd9] top-0 left-0 right-0 bottom-0 w-full h-full z-50">
            <div
                ref={modalRef}
                className="bg-white rounded-20 p-3 w-[190px] top-3 absolute left-3"
            >
                <div className="max-h-[193px] h-full overflow-auto">
                    {sortedDomains?.map((domain, index) => (
                        <div
                            key={index}
                            className="flex items-center justify-between py-3 px-2 border-dotted border-b border-b-gray-100 cursor-pointer hover:text-medium transition-all duration-300"
                            onClick={() => onDomainChange(domain.name, domain)}
                        >
                            <span className="flex items-center gap-3">
                                <DomainIcon logoUrl={domain.logoUrl} name={domain.name} />
                                <span className="text-size-12 text-primary-blue">
                                    {domain.name}
                                </span>
                            </span>
                            {selectedDomain === domain.userDomain && <GreenCheck />}
                        </div>
                    ))}
                </div>
                <button className="bg-blue rounded-7 w-full text-white text-size-12 flex items-center justify-center gap-2 py-2 font-medium mt-3 h-[40px] cursor-pointer"
                    onClick={() => {
                        setShowNewProvider(true)
                        onClose()
                    }}
                >
                    <PlusIcon />
                    Add Account
                </button>
            </div>
        </div>
    );
};
